<template>
  <div class="event-card">
    <div class="event-card-header">
      <!-- <div v-bind:class="'event-color-'+event.color" class="event-title-container"> -->
      <div v-bind:class="'event-color-'+event.color" class="event-title-container">
        <span class="event-title grow">{{ event.name }}</span>
        <!-- <i @click="toggleLike" class="rds-icon rds-icon-stella"></i> -->
        <!-- <div class="icon-container">
          <Stella></Stella>
        </div>-->
      </div>
      <div class="event-date">{{ getEventDateString }}</div>
    </div>
    <div class="event-card-body">
      <div class="event-location">{{locationString}}</div>
      <span class="event-description">{{event.description}}</span>
    </div>
    <div class="event-card-footer">
      <div class="grow" @click="viewUsersLikes">{{interestedPeopleString}}</div>
      <i
        @click="toggleLike"
        v-bind:class="{'like-color-press': userLike}"
        class="rds-icon rds-icon-stella"
      ></i>
    </div>
  </div>
</template>
<script>
// import Stella from '../assets/rds-life-fonticons/stella-test.svg?inline';
import userService from '../services/User.service';
export default {
  name: 'event-card',
  props: ['event'],
  components: {},
  computed: {
    userLike() {
      return this.event.likes.indexOf(userService.user.id) !== -1;
    },
    interestedPeopleString() {
      const count = this.event.likes.length;
      let interestedPeople = '';
      if (count === 0) {
        interestedPeople = 'Dì che ti piace prima di tutti';
      } else if (count === 1) {
        interestedPeople = '1 persona interessata';
      } else {
        interestedPeople = `${count} persone interessate`;
      }
      return interestedPeople;
    },
    getEventDateString() {
      let dateString;
      const start = new Date(this.event.dateStart);
      const end = new Date(this.event.dateEnd);

      if (start.getDate() !== end.getDate()) {
        let startString = start.getDate();
        if (start.getMonth() !== end.getMonth()) {
          startString = start.toLocaleString('it-it', {
            day: '2-digit',
            month: 'long'
          });
        }
        const endString = end.toLocaleString('it-it', {
          day: '2-digit',
          month: 'long'
        });
        dateString = `Dal ${startString} al ${endString}`;
      } else {
        dateString = end.toLocaleString('it-it', {
          day: '2-digit',
          month: 'long'
        });
      }

      return dateString;
    },
    locationString() {
      try {
        let locationArray = this.event.location.split(',');
        const locationPlace = locationArray[0];
        const cityAndProvArr = locationArray[locationArray.length - 2].split(
          ' '
        );
        let locationCity = cityAndProvArr[cityAndProvArr.length - 2];
        if (locationPlace.trim() !== locationCity.trim()) {
          return `${locationPlace}, ${locationCity}`;
        } else {
          return `${locationPlace}`;
        }
      } catch (error) {
        return this.event.location;
      }
    }
  },
  methods: {
    toggleLike() {
      const added = userService.toggleLike('events', this.event.id);
      if (added) {
        this.event.likes.push(userService.user.id);
      } else {
        this.event.likes.splice(
          this.event.likes.indexOf(userService.user.id),
          1
        );
      }
    },
    viewUsersLikes() {
      this.$emit('showUsersLikes', this.event);
    }
  }
};
</script>
<style lang="scss" scoped>
.event-date,
.event-description {
  // font-size: 0.93em;
  font-size: 0.875em;
}
.event-location,
.event-title {
  font-size: 0.95em;
}

.event-card {
  background-color: #ffffff;
  border-radius: $default-border-radius;
  @include shadow-bottom;
}
.event-card-header {
  letter-spacing: 1px;
  padding: 15px 30px;
  position: relative;
  @include dotted-bottom;
  .event-title-container {
    display: flex;
    color: #33b679;
    margin: 0 0 7px;
    &.spettacolo {
      color: #cb4242;
    }
    @each $label, $color in $calendar-colors {
      &.event-color-#{$label} {
        color: $color;
        color: #33b679;
      }
    }
    .event-title {
      font-weight: 600;
    }
  }
}
.event-card-body {
  padding: 15px 30px;
  position: relative;
  border-bottom: rgba(112, 112, 112, 0.12) solid 1px;
  &::after,
  &::before {
    position: absolute;
    top: 0;
    width: 30px;
    height: 30px;
    content: '';
    background-color: #f7f7f7;
    border-radius: 50%;
  }
  &::before {
    left: 0;
    transform: translate(-50%, -50%);
  }
  &::after {
    right: 0;
    transform: translate(50%, -50%);
  }
  .event-location {
    text-transform: uppercase;
    margin: 5px 0 10px;
    letter-spacing: 1px;
  }
  .event-description {
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.6em;
  }
}
.event-card-footer {
  display: flex;
  padding: 20px 30px 20px 30px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875em;
  .grow {
    letter-spacing: 1px;
  }
}
// .rds-icon-stella {
//   padding: 0 12px 0 12px;
// }
</style>
